import {useCallback, useMemo} from "react";
import {get, groupBy, uniqBy} from "lodash";
import NewIOT from "../../../IOT/NewIOT";
import useMQTTFetcher from "../../../hooks/useMQTTFetcher";

const useDeviceShadowStateFetcher = (deviceList, pathToRoot = "device") => {
    const devicesString = useMemo(() => {
        const extractDeviceObj = (value) =>
            pathToRoot ? get(value, pathToRoot) : value;

        const uniqueDevices = uniqBy(
            deviceList,
            (v) => extractDeviceObj(v).DevID
        );

        const simplifiedDevices = uniqueDevices
            .map((v) => {
                const device = extractDeviceObj(v);
                return {
                    GatewayID: device.GatewayID,
                    DevID: device.DevID,
                };
            })
            .sort((a, b) => a.DevID.localeCompare(b.DevID));

        return JSON.stringify(simplifiedDevices);
    }, [deviceList, pathToRoot]);

    const fetchData = useCallback(() => {
        const devices = JSON.parse(devicesString);
        if (!devices.length) return;

        const groupedDevices = Object.values(
            groupBy(devices, (device) => device.GatewayID)
        );
        groupedDevices.forEach((devicesUnderGateway) => {
            NewIOT.startSendingDeviceState(devicesUnderGateway);
        });
    }, [devicesString]);

    useMQTTFetcher(fetchData);
};

export default useDeviceShadowStateFetcher;
